/**
 * HTTP client dùng chung — gọi qua BFF (mdmquery) tại /api.
 *
 * XÁC THỰC: session cookie httpOnly (đặt khi đăng nhập). Mọi request kèm
 * `credentials: 'include'`. KHÔNG còn API key nhúng trong bundle — toàn bộ
 * secret (NanoMDM key, DB) nằm ở backend. RBAC + location do backend enforce.
 */

export const API_BASE = import.meta.env.VITE_API_BASE || '/api';

export class ApiError extends Error {
  constructor(status, path, body) {
    const detail = typeof body === 'string' ? body : (body && body.error) || JSON.stringify(body);
    super(`[${status}] ${path} — ${detail}`);
    this.name = 'ApiError';
    this.status = status;
    this.path = path;
    this.body = body;
  }
}

/**
 * Gọi API qua BFF.
 * @param {string} path            vd '/devices'
 * @param {object} [opts]
 * @param {string} [opts.method]   mặc định GET
 * @param {*}      [opts.json]     body JSON (tự set Content-Type)
 * @param {string} [opts.xml]      body plist/xml thô
 * @returns {Promise<any>} JSON hoặc text
 */
export async function api(path, opts = {}) {
  const { method = 'GET', json, xml, text, blob, contentType } = opts;
  const headers = {};
  let body;
  if (json !== undefined) {
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify(json);
  } else if (xml !== undefined) {
    headers['Content-Type'] = 'application/xml';
    body = xml;
  } else if (text !== undefined) {
    headers['Content-Type'] = 'text/plain';
    body = text;
  } else if (blob !== undefined) {
    if (contentType) headers['Content-Type'] = contentType;
    body = blob; // Blob/ArrayBuffer thô (vd upload ảnh JPEG)
  }
  const res = await fetch(`${API_BASE}${path}`, { method, headers, body, credentials: 'include' });
  const ct = res.headers.get('content-type') || '';
  const payload = ct.includes('application/json')
    ? await res.json().catch(() => null)
    : await res.text().catch(() => '');
  if (!res.ok) throw new ApiError(res.status, path, payload);
  return payload;
}

/** Nối danh sách id thành chuỗi phân tách bằng dấu phẩy (đã encode từng id). */
export function idPath(ids) {
  const arr = Array.isArray(ids) ? ids : [ids];
  return arr.map(encodeURIComponent).join(',');
}
